var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5108",
    width: 16,
    height: 16,
    rx: 8,
    style: {
      fill: "#e7e9ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 13",
    d: "M6429.2 2346.8a.678.678 0 0 1 0-.957l2.846-2.845-2.846-2.845a.677.677 0 1 1 .957-.957l2.846 2.845 2.845-2.845a.677.677 0 1 1 .957.957l-2.846 2.845 2.846 2.845a.677.677 0 0 1-.957.957l-2.845-2.845-2.846 2.845a.678.678 0 0 1-.957 0z",
    transform: "translate(-6425 -2335)",
    style: {
      fill: "#6d7582"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClose);
export default __webpack_public_path__ + "static/media/icn_close.b2f31c1259aa5e94a2dc7452c3757842.svg";
export { ForwardRef as ReactComponent };